import { FC } from "react"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation,Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { IProject } from "../../../store/types"
import CardProject from "../../../components/CardProject/CardProject"
import s from './ProjectExamples.module.scss'

interface IProjectExamplesProps {
    data: IProject[]
}

const ProjectExamples: FC<IProjectExamplesProps> = ({ data }) => {
    if (!data || data.length === 0) return null

    return (
        <section className={s.section}>
            <div className={`${s.container} container`}>
                <h2 className='title'><span />Примеры проектов</h2>
                <Swiper
                    modules={[Navigation,Pagination]}
                    navigation={true}
                    pagination={{ clickable: true }}
                    grabCursor
                    spaceBetween={30}
                    className={s.swiper}
                    breakpoints={{
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 15,
                        },
                        768: {
                            slidesPerView: 2.1,
                            spaceBetween: 20,
                        },
                        1200: {
                            slidesPerView: 3.2,
                            spaceBetween: 30,
                        },
                    }}
                >
                    {data.map((project) => (
                        <SwiperSlide key={project.id} className={s.slide}>
                            <CardProject data={project} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    )
}

export default ProjectExamples
